import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Button from '@mui/material/Button';
import StableMuiDialog from '../../../../common/StableMuiDialog.js';

const UnsentOffersLeaveDialog = ({ open, onStay, onLeaveAnyway }) => (
  <StableMuiDialog open={open} onClose={onStay} maxWidth="sm" fullWidth>
    <DialogTitle>Unsent offers</DialogTitle>
    <DialogContent>
      <DialogContentText>
        You have updated offers which have not been sent to the town. If you do not send them,
        they will not see these new levels in the town portal.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onStay} color="primary" variant="contained">
        Stay on summary table
      </Button>
      <Button onClick={onLeaveAnyway} color="inherit">
        Leave without sending
      </Button>
    </DialogActions>
  </StableMuiDialog>
);

export default UnsentOffersLeaveDialog;
